import styled from 'styled-components'

export const HeaderCell = styled.div`
  max-width: 180px;
  word-wrap: break-word;
  white-space: normal;
  line-height: 1.4;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 60px;
`

export const CompactHeaderCell = styled.div`
  max-width: 120px;
  word-wrap: break-word;
  white-space: normal;
  line-height: 1.4;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 60px;
`
